import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import Title from "../../extra/Title";
import { getCoinLeaderboard } from "../../store/auditLog/auditLog.action";

const CoinsLeader = () => {
  const dispatch = useDispatch();
  const { leaderboard, leaderboardTotal } = useSelector((state) => state.auditLog);
  const [search, setSearch] = useState("");
  // Row whose device details popup is open (null = closed).
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [page, setPage] = useState(1);
  const limit = 25;

  useEffect(() => {
    dispatch(getCoinLeaderboard({ search, start: page, limit }));
  }, [dispatch, search, page]);

  const totalPages = Math.max(1, Math.ceil((leaderboardTotal || 0) / limit));

  return (
    <div className="mainCategory">
      <Title name="Coins Leader" />

      <div className="row mb-3 mt-3">
        <div className="col-12 col-md-6 mb-2">
          <input
            type="text"
            className="form-control"
            placeholder="Search by name or email..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
          />
        </div>
        <div className="col-12 col-md-6 mb-2 d-flex align-items-center">
          <span style={{ color: "#8A857F" }}>
            Total wallets: <strong>{leaderboardTotal}</strong>
          </span>
        </div>
      </div>

      <div className="customTable">
        <div className="primeMain">
          <table width="100%" className="primeTable text-center">
            <thead className="sticky-top" style={{ top: "-1px", zIndex: 1 }}>
              <tr>
                <th className="fw-bold py-3">Rank</th>
                <th className="fw-bold py-3">User</th>
                <th className="fw-bold py-3">Unique ID</th>
                <th className="fw-bold py-3">Balance</th>
                <th className="fw-bold py-3">Lifetime Earned</th>
                <th className="fw-bold py-3">Device</th>
                <th className="fw-bold py-3">Joined</th>
              </tr>
            </thead>
            <tbody>
              {leaderboard && leaderboard.length > 0 ? (
                leaderboard.map((row, index) => (
                  <tr key={row?._id || index}>
                    <td style={{ fontWeight: 700 }}>{(page - 1) * limit + index + 1}</td>
                    <td style={{ fontSize: "12px", textAlign: "left" }}>
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={row?.image || "/dummy.png"}
                          alt=""
                          height={32}
                          width={32}
                          className="rounded-circle"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/dummy.png";
                          }}
                        />
                        <div>
                          <strong>
                            {`${row?.firstName || ""} ${row?.lastName || ""}`.trim() || "-"}
                          </strong>
                          <br />
                          <span style={{ color: "#8A857F" }}>{row?.email}</span>
                        </div>
                      </div>
                    </td>
                    <td style={{ fontSize: "12px" }}>{row?.uniqueId || "-"}</td>
                    <td style={{ fontWeight: 700, color: "#D4A129" }}>
                      {row?.balance || 0}
                    </td>
                    <td style={{ fontSize: "12px" }}>{row?.lifetimeEarned || 0}</td>
                    <td>
                      {row?.deviceId || row?.deviceModel ? (
                        <i
                          className="fa-solid fa-circle-info"
                          title="View device info"
                          style={{ color: "#D4A129", cursor: "pointer", fontSize: "16px" }}
                          onClick={() => setDeviceInfo(row)}
                        ></i>
                      ) : (
                        <span style={{ color: "#8A857F" }}>-</span>
                      )}
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      {row?.joinedAt ? dayjs(row.joinedAt).format("DD/MM/YY") : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} style={{ padding: "30px", color: "#8A857F" }}>
                    No wallets yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 12,
          marginTop: 14,
        }}
      >
        <button
          disabled={page <= 1}
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          style={{
            padding: "7px 14px",
            borderRadius: 8,
            border: "1px solid #E8E1D3",
            background: page <= 1 ? "#F3F0E9" : "#fff",
            color: "#1A1614",
            cursor: page <= 1 ? "default" : "pointer",
            fontSize: 13,
          }}
        >
          Prev
        </button>
        <span style={{ fontSize: 13, color: "#8A857F" }}>
          Page {page} / {totalPages}
        </span>
        <button
          disabled={page >= totalPages}
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          style={{
            padding: "7px 14px",
            borderRadius: 8,
            border: "1px solid #E8E1D3",
            background: page >= totalPages ? "#F3F0E9" : "#fff",
            color: "#1A1614",
            cursor: page >= totalPages ? "default" : "pointer",
            fontSize: 13,
          }}
        >
          Next
        </button>
      </div>

      {/* Device info popup */}
      {deviceInfo && (
        <div className="mainDialogue fade-in" onClick={() => setDeviceInfo(null)}>
          <div
            className="Dialogue"
            style={{ width: "460px", maxWidth: "95%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="dialogueHeader">
              <div className="headerTitle fw-bold">Device Information</div>
              <div className="closeBtn" onClick={() => setDeviceInfo(null)}>
                <i className="fa-solid fa-xmark"></i>
              </div>
            </div>
            <div className="dialogueMain" style={{ padding: "20px" }}>
              <div className="mb-3">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <img
                    src={deviceInfo?.image || "/dummy.png"}
                    alt=""
                    height={40}
                    width={40}
                    className="rounded-circle"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/dummy.png";
                    }}
                  />
                  <div className="text-dark">
                    <strong>
                      {`${deviceInfo?.firstName || ""} ${deviceInfo?.lastName || ""}`.trim() || "-"}
                    </strong>
                    <br />
                    <span style={{ color: "#8A857F", fontSize: "12px" }}>
                      {deviceInfo?.email}
                    </span>
                  </div>
                </div>

                <Row label="Device Model" value={deviceInfo?.deviceModel || "—"} />
                <Row label="Platform" value={deviceInfo?.platform || "—"} />
                <Row
                  label="Device ID"
                  value={deviceInfo?.deviceId || "—"}
                  breakAll
                />
                <Row label="Unique ID" value={deviceInfo?.uniqueId || "—"} />
                <Row
                  label="Joined"
                  value={
                    deviceInfo?.joinedAt
                      ? dayjs(deviceInfo.joinedAt).format("DD MMM YYYY, HH:mm")
                      : "—"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const Row = ({ label, value, breakAll }) => (
  <div className="d-flex justify-content-between py-2" style={{ borderBottom: "1px solid #F0EADB" }}>
    <span style={{ color: "#8A857F", fontSize: "13px" }}>{label}</span>
    <span
      className="text-dark"
      style={{
        fontSize: "13px",
        fontWeight: 600,
        textAlign: "right",
        maxWidth: "260px",
        wordBreak: breakAll ? "break-all" : "normal",
      }}
    >
      {value}
    </span>
  </div>
);

export default CoinsLeader;
